import React from "react"
import { CircularProgress, Flex, Text } from "@chakra-ui/react"
import Icon from "components/elements/Icon"

type Props = {
  capacity: number
  confirmedGuests: number
}

export const capacityColor = (capacity: number, confirmedGuests: number) => (
  confirmedGuests >= capacity ? "orange.300" : "blue.300"
)

type RingProps = { capacity: number | null, confirmedGuests: number, size?: string }

export const CapacityRing = ({ capacity, confirmedGuests, size = "36px" }: RingProps) => (
  <CircularProgress
    value={capacity ? Math.min((confirmedGuests / capacity) * 100, 100) : 0}
    color={capacity ? capacityColor(capacity, confirmedGuests) : "blue.300"}
    trackColor="gray.200"
    thickness="11px"
    size={size}
    capIsRound
  />
)

const CapacityStat = ({ capacity, confirmedGuests }: Props) => (
  <Flex align="center" gap={3} whiteSpace="nowrap">
    <CapacityRing capacity={capacity} confirmedGuests={confirmedGuests} />
    <Flex align="baseline">
      <Text
        as="span"
        fontSize="2xl"
        fontWeight="semibold"
        color={confirmedGuests >= capacity ? "orange.600" : undefined}
      >
        {confirmedGuests.toLocaleString()}
      </Text>
      <Text as="span" ml={1} mr={1.5}>/ {capacity.toLocaleString()}</Text>
      <Text as="span">Confirmed</Text>
    </Flex>
  </Flex>
)

export const SetCapacity = () => (
  <Flex align="center" gap={1.5} color="gray.600" _hover={{ color: "blue.500" }}>
    <Icon icon="plus" size={3.5} />
    <Text>Set Capacity</Text>
  </Flex>
)

export default CapacityStat
